;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();import type { Step } from "react-joyride";
import { ACTIONS } from "react-joyride";
import { isTourTargetVisible } from "@/features/onboarding-tours/orchestrator/wait-for-tour-target";
import type { TourStepData } from "@/features/onboarding-tours/types/tour-definition";

function getStepData({ step }: { step: Step | undefined }): TourStepData {
	return (step?.data ?? {}) as TourStepData;
}

function shouldSkipHiddenStep({ step }: { step: Step | undefined }): boolean {
	const stepData = getStepData({ step });
	if (!stepData.skipWhenTargetHidden) {
		return false;
	}

	const skipTarget =
		typeof step?.target === "string" ? step.target : stepData.advanceWhenTarget;
	if (!skipTarget) {
		return false;
	}

	return !isTourTargetVisible({ target: skipTarget });
}

export function resolveSkippedForwardIndex({
	index,
	steps,
}: {
	index: number;
	steps: Step[];
}): number | undefined {
	if (!shouldSkipHiddenStep({ step: steps[index] })) {
		return undefined;
	}

	let nextIndex = index + 1;
	while (nextIndex < steps.length) {
		if (!shouldSkipHiddenStep({ step: steps[nextIndex] })) {
			return nextIndex;
		}
		nextIndex += 1;
	}

	return Math.max(steps.length - 1, 0);
}

export function resolveStepIndexAfterAction({
	action,
	index,
	steps,
}: {
	action: string;
	index: number;
	steps: Step[];
}): number | undefined {
	if (action === ACTIONS.NEXT) {
		const stepData = getStepData({ step: steps[index] });
		if (stepData.advanceOnNext) {
			return stepData.advanceOnNext.stepIndex;
		}

		if (!stepData.skipNextStepWhenHidden) {
			return undefined;
		}

		if (isTourTargetVisible({ target: stepData.skipNextStepWhenHidden })) {
			return undefined;
		}

		let nextIndex = index + 2;
		while (
			nextIndex < steps.length &&
			shouldSkipHiddenStep({ step: steps[nextIndex] })
		) {
			nextIndex += 1;
		}

		return Math.min(nextIndex, steps.length - 1);
	}

	if (action === ACTIONS.PREV) {
		let previousIndex = index - 1;
		while (
			previousIndex >= 0 &&
			shouldSkipHiddenStep({ step: steps[previousIndex] })
		) {
			previousIndex -= 1;
		}

		return Math.max(previousIndex, 0);
	}

	return undefined;
}
